import type { HitProps } from '@components/algolia/Hit';
import { isQuickAddEligible } from '@utils/algolia/isQuickAddEligible';

/**
 * Whether the Why Choose chip can quick add this product: listed, not a gift
 * card, and its default colour can be bought online. Judged on the default
 * colour only — once the chip renders, a colour picked in the popover that
 * can't be bought online gets Quick Add's own unavailable state instead of
 * the chip vanishing mid-flow. Shared by the picker and the chip so they
 * never disagree about a product. Kept apart from the picker because the
 * chip runs in the browser, and the picker imports server-only fetchers.
 */
export const canWhyChooseQuickAdd = (hit: HitProps): boolean =>
  isQuickAddEligible(hit, hit.colour);

export default canWhyChooseQuickAdd;
